import { type PushNotificationsManagerInterface } from '@app/services/PushNotificationsManager'

import { createThunk } from '@app/store/thunk'

export function getPushNotificationsManager() {
  return createThunk((_dispatch, _getState, context) => context.lookupEnsure<PushNotificationsManagerInterface>(PushNotificationsSymbol))
}
export function setPushNotificationsManager(value: PushNotificationsManagerInterface) {
  return createThunk((_dispatch, _getState, context) => context.getRootContext().set(PushNotificationsSymbol, value))
}

const PushNotificationsSymbol = Symbol('PushNotificationsManager')
